export const ASTERIA_CUSTOM_SCENARIO = 'Våran egna prognos';
